export default {"src":"/_next/static/media/leftLine.ca9b98b0.svg","height":2,"width":91,"blurWidth":0,"blurHeight":0};